"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOrderstatus = exports.Checkout = exports.AddToCart = exports.RemoveWishlistItem = exports.AddtoWishlist = exports.getCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var AxiosClient_1 = require("../utils/AxiosClient");
var react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function getCookie(name) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    var gettoken = js_cookie_1.default.get(name);
    return gettoken;
}
exports.getCookie = getCookie;
function AddtoWishlist(ProductID) {
    var token = getCookie("token");
    if (token) {
        AxiosClient_1.AxiosClient.post("/products/wishlist/add/".concat(ProductID), null, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            if (response.data.status == 201) {
                react_hot_toast_1.default.remove();
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                react_hot_toast_1.default.success(response.data.message);
            }
        })
            .catch(function (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            react_hot_toast_1.default.error(error.response.data.message);
        });
    }
    else {
        react_hot_toast_1.default.error("Login to add add item to wishlist");
    }
}
exports.AddtoWishlist = AddtoWishlist;
function RemoveWishlistItem(ProductID) {
    var token = getCookie("token");
    var checkresposnse = false;
    if (token) {
        AxiosClient_1.AxiosClient.delete("/products/wishlist/remove/".concat(ProductID), {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            if (response.data.status == 201) {
                react_hot_toast_1.default.remove();
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                react_hot_toast_1.default.success(response.data.message);
                checkresposnse = true;
            }
        })
            .catch(function (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            react_hot_toast_1.default.error(error.response.data.message);
        });
        return checkresposnse;
    }
    else {
        react_hot_toast_1.default.error("Login to continue");
    }
    return checkresposnse;
}
exports.RemoveWishlistItem = RemoveWishlistItem;
function AddToCart(ProductID) {
    var token = getCookie("token");
    if (token) {
        AxiosClient_1.AxiosClient.post("/cart/add/".concat(ProductID), null, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            if (response.data.statusCode == 200) {
                react_hot_toast_1.default.remove();
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                react_hot_toast_1.default.success(response.data.message);
            }
        })
            .catch(function (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            react_hot_toast_1.default.error(error.response.data.message);
        });
    }
    else {
        react_hot_toast_1.default.error("Login to add Item to Cart");
    }
}
exports.AddToCart = AddToCart;
function Checkout() {
    return __awaiter(this, void 0, void 0, function () {
        var token, cartID;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = getCookie("token");
                    if (!token) return [3 /*break*/, 2];
                    return [4 /*yield*/, AxiosClient_1.AxiosClient.get("/cart/view", {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                            },
                        })
                            .then(function (response) {
                            console.log(response);
                            if (response.data.statusCode == 200) {
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                cartID = response.data.cart.id;
                            }
                        })
                            .catch(function (error) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            react_hot_toast_1.default.error(error.response.data.message);
                        })];
                case 1:
                    _a.sent();
                    // payment with stripe
                    if (cartID) {
                        AxiosClient_1.AxiosClient.post("/checkoutcart/".concat(cartID), null, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                            },
                        })
                            .then(function (response) {
                            console.log(response);
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            window.location.href = response.data.url;
                        })
                            .catch(function (error) {
                            console.log(error);
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            react_hot_toast_1.default.error(error.response.data.message);
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    react_hot_toast_1.default.error("Login to Checkout");
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.Checkout = Checkout;
function setOrderstatus(orderid, value) {
    var token = getCookie("token");
    if (token) {
        AxiosClient_1.AxiosClient.patch("/orders/change/".concat(orderid), {
            status: value,
        }, {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            console.log(response);
            if (response.data.statusCode == 200) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                react_hot_toast_1.default.error(response.data.message);
            }
        })
            .catch(function (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            react_hot_toast_1.default.error(error.response.data.message);
        });
    }
}
exports.setOrderstatus = setOrderstatus;
